import {
  ENABLE_AMENDMENT_V2_JOURNEY,
  ENABLE_ANNUAL_REPORT_V2_JOURNEY,
  ENABLE_ZB_BANKING_SUNSET_PH1,
  RELEASE_SQUARESPACE_DOMAINS_RESELLER,
  RELEASE_SQUARESPACE_WEBSITES_RESELLER,
} from '#client/constants/experimentsFlags';

/**
 * Mapping of product IDs to their corresponding experiment flags.
 * These flags are used during the deprecation of zenreg,
 * as part of the gradual transition to new journey flows.
 * @type {object<string, string>}
 */
export const PRODUCT_FLAG_MAPPING = {
  amendment: ENABLE_AMENDMENT_V2_JOURNEY,
  'annual-report': ENABLE_ANNUAL_REPORT_V2_JOURNEY,
  'domain-name-reg': RELEASE_SQUARESPACE_DOMAINS_RESELLER,
  's-corp-bundle': ENABLE_ZB_BANKING_SUNSET_PH1,
  'static-website-sqsp': RELEASE_SQUARESPACE_WEBSITES_RESELLER,
};
